import React, { useState } from 'react';
import { Card } from '../components/ui/Card';
import SafeIcon from '../common/SafeIcon';
import { FiPlus, FiMinus } from 'react-icons/fi';

const faqs = [
  {
    q: "How does TableTurn sync with my existing POS?",
    a: "We integrate with leading POS systems like Toast, Square, and Clover via our secure API. Orders fired in your POS automatically populate the BOH Prep Lanes in TableTurn."
  },
  {
    q: "What makes this different from a standard reservation tool?",
    a: "Standard tools focus on the guest booking. TableTurn focuses on the operational heartbeat—connecting the kitchen's capacity to the floor's seating pace to maximize turns."
  },
  {
    q: "Is the data in this demo real?",
    a: "No, all data in this environment is simulation-based dummy data designed to show the platform's capabilities without exposing private restaurant analytics."
  },
  {
    q: "Does TableTurn handle staff scheduling?",
    a: "Yes, we have a dedicated Staffing module that correlates labor costs against real-time revenue to ensure you are never over-staffed during slow periods."
  },
  {
    q: "How long is the setup process?",
    a: "Most restaurants are live within 48 hours. Our team assists with floorplan mapping and BOH station configuration remotely."
  }
];

export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div className="p-6 max-w-3xl mx-auto space-y-8">
      <header>
        <h1 className="text-3xl font-bold text-receiptWhite tracking-tight">OPERATIONAL FAQ</h1>
        <p className="text-receiptMuted mt-2">Common questions about the TableTurn infrastructure.</p>
      </header>

      <div className="space-y-4">
        {faqs.map((faq, idx) => (
          <div key={idx} className="border border-chefPanel rounded-lg bg-chefDark overflow-hidden">
            <button 
              onClick={() => setOpenIndex(openIndex === idx ? -1 : idx)}
              className="w-full flex items-center justify-between p-5 text-left hover:bg-chefPanel transition-colors"
            >
              <span className="text-receiptWhite font-medium">{faq.q}</span>
              <SafeIcon icon={openIndex === idx ? FiMinus : FiPlus} className="text-chiliRed" />
            </button>
            {openIndex === idx && (
              <div className="p-5 pt-0 text-receiptMuted text-sm leading-relaxed border-t border-chefPanel/50 bg-chefBlack/30">
                {faq.a}
              </div>
            )}
          </div>
        ))}
      </div>

      <Card className="bg-chiliDark/10 border-chiliRed/20 mt-12">
        <div className="flex flex-col md:flex-row items-center gap-6 p-4 text-center md:text-left">
          <div className="flex-1">
            <h4 className="text-receiptWhite font-bold">Still have questions?</h4>
            <p className="text-receiptMuted text-sm mt-1">Our deployment specialists are available 24/7 for live support.</p>
          </div>
          <button className="bg-chiliRed text-white px-6 py-2 rounded font-mono text-sm uppercase">Contact Support</button>
        </div>
      </Card>
    </div>
  );
};